import React from 'react';
import {ThemeProvider, Toaster, ToasterComponent, ToasterProvider} from '@gravity-ui/uikit';
import {AppRouter} from './app/router';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {AvatarCacheProvider, setupApiInterceptors} from './shared';

const toaster = new Toaster();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 минут кэширования
      retry: 2,
    },
  },
});

// Настраиваем interceptors для обработки ошибок авторизации
setupApiInterceptors(queryClient);

function App() {
  return (
    <ToasterProvider toaster={toaster}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={'light'}>
          <AvatarCacheProvider>
            <AppRouter />
            <ToasterComponent />
          </AvatarCacheProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ToasterProvider>
  );
}

export default App;
